"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToLetterDigits = void 0;
const hex_hash_converter_1 = require("./hex-hash-converter");
const hexToLetterDigits = (hexStr) => {
    const converter = new hex_hash_converter_1.HexHashConverter([
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
    ]);
    return converter.convert(hexStr);
};
exports.hexToLetterDigits = hexToLetterDigits;
